import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DashDateString } from 'routes/HumanResourcesModule/business/types';
import { RQAPICallWithData } from 'store/APIClient';
import { SIMULATION_ENDPOINT_PREFIX } from '../constants';
import { HrSimulation } from '../types';

const SEMI_TREATMENT_API_KEY = 'hr_simulation_semi_treatment';

export type SemiTreatmentHypothesis = {
    agentSoftwareId: string;
    startDate: DashDateString;
    endDate: DashDateString;
};

export const useSemiTreatmentOfSimulation = (
    hrSimulation: HrSimulation,
): UseQueryResult<SemiTreatmentHypothesis[]> =>
    useQuery({
        queryKey: [SEMI_TREATMENT_API_KEY, hrSimulation.id],

        queryFn: async () => {
            const response = await RQAPICallWithData<SemiTreatmentHypothesis[]>(
                {
                    endpoint: `${SIMULATION_ENDPOINT_PREFIX}/${hrSimulation.id}/semi_treatment_hypotheses`,
                },
            );
            return response.content.data;
        },

        // A day in milliseconds
        staleTime: 1000 * 3600 * 24,

        initialData: [],

        // This is needed so that RQ fetches the data at least once before
        // caching it for a long time. Without it, the initial data is considered
        // fresh for as long as staleTime. The value is a timestamp.
        initialDataUpdatedAt: 0,
    });
